module.exports = __webpack_public_path__ + "img/4064019910.ddbaf617.jpg";